<template>
    <div>
        <table id="historyTable" class="table" style="width:100%" />
    </div>
</template>

<script>
export default {
    props: {
        FieldDataName: {
            type: String,
            required: true
        },
        RawDataId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            tableId: "#historyTable"
        };
    },
    mounted() {
        var self = this;
        this.$nextTick(function() {
            self.getEditHistoryLog();
        });
    },
    methods: {
        getEditHistoryLog() {
            var self = this;
            $(this.tableId).DataTable(dataTableOption({
                "ajax": {
                    "url": self.FieldDataName + "/GetHistory",
                },
                "data": {
                    Id: self.RawDataId,
                },
                "order": [[ 0, "desc" ]],
                "columnDefs": [
                    { targets: "_all", defaultContent: "-" },
                ],
			        "columns": [
			        	{ data: "id", title: "ID" },
					   	{ data: "propertyChanges", title: "Original Value", orderable: false, render: function(data, type, row, meta) {
                        var oriData = "<ul>";
                        data.forEach(item => {
                            oriData = oriData + ("<li>" + item.propertyName + " (" + item.originalValue + ") </li>");
                        });
                        oriData + "</ul>";
                        return oriData;
                    }
                    },
                    { data: "propertyChanges", title: "New Value", orderable: false, render: function(data, type, row, meta) {
                        var changeData = "<ul>";
                        data.forEach(item => {
                            changeData = changeData + ("<li>" + item.propertyName + " (" + item.newValue + ") </li>");
                        });
                        changeData + "</ul>";
                        return changeData;
                    }
                    },
                    { data: "entityChangeSet.reason", title: "Reason" },
                    { data: "entityChangeSet.user.userName", title: "Changed by" },
                    { data: "changeTime", title: "Changed At", render: function(date) { return self.formatCreationTime(date); } },
                ],
                "exportTitle": self.FieldDataName + "History List",
            }));
        },
        redrawTable() {
            if ($.fn.DataTable.isDataTable(this.tableId)) {   
				  $(this.tableId).DataTable().destroy();
				  $(this.tableId).empty();
            }
            this.getEditHistoryLog();
        },
    }
};
</script>

<style lang="css" scoped>
.samplingChangeTitle{
	margin-bottom: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/History/RawEditHistoryTable.vue